import { _GetUrl } from "src/components/UI/Shared/handler";

export const PanelPaths = [
  "/Geo".toLocaleLowerCase(),
  "/Geo/".toLocaleLowerCase(),
  "/Geo/layers".toLocaleLowerCase(),
  "/Geo/contact-us".toLocaleLowerCase(),
  `/Geo/${_GetUrl(2, 0)}`.toLocaleLowerCase(),
  `/Geo/${_GetUrl(2, 1)}`.toLocaleLowerCase(),
  `/Geo/${_GetUrl(2, 2)}`.toLocaleLowerCase(),
  `/Geo/${_GetUrl(3, 0)}`.toLocaleLowerCase(),
  `/Geo/${_GetUrl(3, 1)}`.toLocaleLowerCase(),
];
